import ACTIONS from "./actions";

export const initialState = {
  status: {
    isLoading: true,
    isError: false,
    data: [],
  },
};

function fleetSearchReducer(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.FETCH_FLEET_SEARCH_INIT: {
      return {
        ...state,
        isLoading: true,
        isError: false,
      };
    }

    case ACTIONS.FETCH_FLEET_SEARCH_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isError: false,
        data: action.payload,
      };
    }

    case ACTIONS.FETCH_FLEET_SEARCH_FAILURE: {
      return {
        ...state,
        isLoading: false,
        isError: true,
      };
    }

    default:
      return state;
  }
}

export default fleetSearchReducer;
